import React from 'react';
import { cn } from '@/lib/utils';
import { Store } from 'lucide-react';

interface AuthLayoutProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({ children, footer }) => {
  return (
    <div
      data-testid="auth-layout"
      className="min-h-screen flex flex-col bg-slate-50 dark:bg-slate-950"
    >
      {/* Main Content */}
      <div className="flex-1 flex items-center justify-center p-4 sm:p-8">
        <div className="w-full max-w-md">
          {/* Brand Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center gap-3 mb-2">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-indigo-500 to-indigo-600 flex items-center justify-center shadow-lg shadow-indigo-500/20">
                <Store className="w-5 h-5 text-white" strokeWidth={1.5} />
              </div>
              <span
                data-testid="auth-brand-name"
                className="font-heading font-bold text-2xl text-slate-900 dark:text-slate-100"
              >
                SmartStore Admin
              </span>
            </div>
            <p className="text-sm text-slate-500 dark:text-slate-400">
              Admin & Support Console
            </p>
          </div>

          {/* Card Content */}
          <div
            data-testid="auth-card"
            className={cn(
              'bg-white dark:bg-slate-900',
              'border border-slate-200 dark:border-slate-800',
              'rounded-xl shadow-xl shadow-slate-200/50 dark:shadow-slate-950/50',
              'p-6 sm:p-8'
            )}
          >
            {children}
          </div>

          {/* Footer Slot */}
          {footer && (
            <div className="mt-6">
              {footer}
            </div>
          )}
        </div>
      </div>

      {/* Page Footer */}
      <footer
        data-testid="auth-footer"
        className="py-4 text-center border-t border-slate-200 dark:border-slate-800"
      >
        <p className="text-xs text-slate-400 dark:text-slate-500 mb-1">
          SmartStore Admin Console
        </p>
        <div className="flex items-center justify-center gap-3 text-xs">
          <a
            href="#privacy"
            className="text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-400 transition-colors"
          >
            Privacy
          </a>
          <span className="text-slate-300 dark:text-slate-700">|</span>
          <a
            href="#terms"
            className="text-slate-400 dark:text-slate-500 hover:text-slate-600 dark:hover:text-slate-400 transition-colors"
          >
            Terms
          </a>
        </div>
      </footer>
    </div>
  );
};
